
<h2 mat-dialog-title>Edit Course</h2>

<mat-dialog-content>

    <mat-form-field>

        <input matInput
                placeholder=" Title">

    </mat-form-field>

  <mat-slide-toggle class="promo" color="primary">
    Course in promotion?
  </mat-slide-toggle>

    <mat-form-field>

        <textarea matInput placeholder="Description">

        </textarea>

    </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions>

    <button mat-raised-button>
        Close
    </button>

    <button mat-raised-button color="primary">
        Save
    </button>

</mat-dialog-actions>


